const GET_ACCOUNT_STATEMENTS_URL = `${BACKOFFICE_API_URL}/accounts/:id/statements`
const GET_ACCOUNTS_URL = `${BACKOFFICE_API_URL}/accounting/trading-accounts`

export { GET_ACCOUNT_STATEMENTS_URL, GET_ACCOUNTS_URL }
